import {
  Droplets,
  Flame,
  Users,
  Dumbbell,
  Gamepad2,
  Monitor,
  UtensilsCrossed,
  Sparkles,
} from "lucide-react";
import ResortTemplate from "@/components/ResortTemplate";
import heroMuroAlto1 from "@/assets/hero-muro-alto-1.jpg";
import heroMuroAlto2 from "@/assets/hero-muro-alto-2.jpg";
import heroMuroAlto3 from "@/assets/hero-muro-alto-3.jpg";
import heroMuroAlto4 from "@/assets/hero-muro-alto-4.jpg";
import heroMuroAlto5 from "@/assets/hero-muro-alto-5.jpg";
import fachada from "@/assets/fachada.jpg";

const ExclusiveGramado = () => {
  return (
    <ResortTemplate
      developmentSlug="exclusive-gramado"
      name="Exclusive Gramado"
      location="Gramado, RS"
      highlightLabel="Empreendimento Exclusivo"
      heroImage={fachada}
      heroDescription="Contemporâneo, sofisticado e aconchegante. Uma experiência única no coração da Serra Gaúcha, perfeita para férias em família ou viagens de negócios."
      rating={{ value: "4.8", reviews: "Hospedagem premiada na Serra Gaúcha" }}
      primaryCtaTo="/busca?empreendimento=Exclusive%20Gramado"
      about={{
        eyebrow: "O Empreendimento",
        title: "Sofisticação contemporânea no coração de Gramado",
        paragraphs: [
          "Contemporâneo, sofisticado, aconchegante e no seu tempo. O Exclusive Gramado é a escolha perfeita em cada detalhe — da arquitetura moderna à localização privilegiada, das férias em família às viagens de negócios.",
          "Exclusividade e modernidade ao lado de tudo o que faz a Serra Gaúcha um destino incrível, com fácil acesso ao Lago Negro, Catedral da Pedra e às atrações da Região das Hortênsias.",
        ],
        image: heroMuroAlto1,
        imageAlt: "Exclusive Gramado — vista aérea",
        stats: [
          { value: "100%", label: "Climatizado" },
          { value: "Premium", label: "Localização" },
          { value: "24/7", label: "Atendimento" },
        ],
      }}
      gallery={{
        title: "Cada detalhe pensado para encantar",
        description:
          "Da arquitetura moderna à decoração refinada, viva uma experiência exclusiva em cada ambiente.",
        items: [
          { src: fachada, alt: "Fachada do Exclusive Gramado", span: "big" },
          { src: heroMuroAlto2, alt: "Lounge com lareira" },
          { src: heroMuroAlto3, alt: "Suíte sofisticada" },
          { src: heroMuroAlto4, alt: "Área gastronômica", span: "wide" },
          { src: heroMuroAlto5, alt: "Espaço wellness" },
          { src: heroMuroAlto1, alt: "Áreas de convivência" },
        ],
      }}
      features={{
        title: "Comodidades pensadas para o seu conforto",
        description:
          "Conforto e sofisticação são os principais diferenciais para você e sua família aproveitarem férias incríveis.",
        items: [
          {
            icon: Droplets,
            title: "Piscina",
            description: "Área de lazer aquática para toda a família, climatizada para a Serra Gaúcha.",
          },
          {
            icon: Sparkles,
            title: "SPA",
            description: "Espaço dedicado ao relaxamento, tratamentos exclusivos e bem-estar.",
          },
          {
            icon: Flame,
            title: "Fire Pit",
            description: "Área de convivência ao ar livre com lareira para noites aconchegantes.",
          },
          {
            icon: Users,
            title: "Espaço Kids",
            description: "Área recreativa especialmente preparada para crianças, com supervisão.",
          },
          {
            icon: Dumbbell,
            title: "Academia",
            description: "Equipamentos modernos para manter a forma durante a sua estadia.",
          },
          {
            icon: Gamepad2,
            title: "Sala de Jogos",
            description: "Entretenimento para todas as idades em um ambiente moderno.",
          },
          {
            icon: Monitor,
            title: "Cyber Espaço",
            description: "Computadores e internet de alta velocidade para o trabalho ou estudo.",
          },
          {
            icon: UtensilsCrossed,
            title: "Gastronomia",
            description: "Sabores da culinária colonial e contemporânea com carinho em cada prato.",
          },
        ],
      }}
      location_section={{
        title: "Bem localizado na Serra Gaúcha",
        description:
          "Em Gramado, com acesso direto às principais atrações da Região das Hortênsias.",
        contact: {
          address: "Av. das Hortênsias, 4079 — Av. Central, CEP 95670-000",
          cityState: "Gramado, RS",
          phone: "+55 (54) 0000-0000",
          travelInfo:
            "A 110 km de Porto Alegre — cerca de 2h pela estrada e a poucos passos do centro de Gramado.",
          mapEmbedUrl:
            "https://www.google.com/maps?q=Av.+das+Hort%C3%AAnsias,+4079,+Gramado+-+RS&output=embed&hl=pt-BR&z=15",
          directionsUrl:
            "https://www.google.com/maps/dir/?api=1&destination=Av.%20das%20Hort%C3%AAnsias%2C%204079%2C%20Gramado%20-%20RS",
        },
      }}
    />
  );
};

export default ExclusiveGramado;
